import parse from "html-react-parser";
import { DropdownElementType, OptionType } from "../helpers/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/pro-light-svg-icons";
import { useEffect, useState } from "react";

type Props = {
    value: string;
    error: string | null;
    onChange: (value: string) => void;
};

const AutoComplete = (props: any) => {
    const {
        value,
        label,
        type = "text",
        classes,
        name,
        placeholder,
        defaultValue,
        disabled,
        onChange,
        error,
        maxLength,
        autoComplete,
        col,
        startIcon,
        startText,
        showValidation,
        options,
        description
    } = props;

    const [showOptions, setShowOptions] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState<OptionType[]>([]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }



    const Option = ({ item }: { item: OptionType }) => {
        const handleChange = () => {
            onChange(item.value);
        }

        return (
            <li
                className={`dropdown-item ${value && value === item.value ? 'bg-primary-subtle' : ''}`}
                onClick={handleChange}
            >
                {item.label}
            </li>
        );
    }

    const validationClass = () => {
        if (disabled || showValidation === false) return '';

        if (value === null || value === undefined) return '';

        if (error) return 'is-invalid';

        return 'is-valid';
    };


    useEffect(() => {
        setFilteredOptions(
            options?.filter((option: OptionType) => option.label.toLowerCase().includes(value.toLowerCase())) ?? []
        )
    }, [value])

    return (
        <div className={col}>
                    <label className="form-label">{label}</label>
                    {description && <div className="text-muted small mb-2">{parse(description)}</div>}
                    <div className="input-group dropdown w-100">
                        {startIcon || startText ? (
                            <span className="input-group-text text-uppercase" style={{ backgroundColor: 'var(--bs-secondary-bg)' }}>
                                {startIcon ? (
                                    <FontAwesomeIcon icon={["fal", startIcon as IconName]} />
                                ) : (
                                    'test'
                                )}
                            </span>
                        ) : null}
        
                        <input
                            value={value}
                            type={type}
                            name={name}
                            className={`form-control ${showValidation === false ? '' : !disabled && error && value ? 'is-invalid' : !disabled && value ? 'is-valid' : ''} ${classes}`}
                            /* className={`form-control ${classes} ${validationClass()}`} */
                            onChange={handleChange}
                            defaultValue={defaultValue}
                            placeholder={placeholder}
                            disabled={disabled}
                            maxLength={maxLength ?? 100}
                            autoComplete={autoComplete}
                            onFocus={() => setShowOptions(true)}
                            onBlur={() => setTimeout(() => setShowOptions(false), 200)}
                        />
                        {showOptions && options && filteredOptions.length > 0 && (
                            <ul className="dropdown-menu dropdown-options w-100" style={{display: 'block'}}>
                                {filteredOptions.map((option: OptionType) => (
                                    <Option key={option.value} item={option} />
                                ))}
                            </ul>
                        )}
                        {validationClass() === 'is-invalid' && error && error !== "hidden" && (
                            <div className="invalid-feedback">{parse(error)}</div>
                        )}
                    </div>
                </div>
    )
}

export default AutoComplete;